import { useSiteTheme } from '@/hooks/useApplyUITheme';

interface EmailLogAvatarProps {
  name?: string;
  email?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
};

const backgroundColors = [
  'bg-blue-600',
  'bg-purple-600',
  'bg-green-600',
  'bg-orange-600',
  'bg-pink-600',
  'bg-indigo-600',
  'bg-teal-600',
  'bg-red-600',
];

function getInitials(name?: string, email?: string): string {
  if (name && name.trim()) {
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
  }

  if (email) {
    const localPart = email.split('@')[0];
    return localPart.substring(0, 2).toUpperCase();
  }

  return '??';
}

function getBackgroundColor(name?: string, email?: string): string {
  const str = name || email || '';
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % backgroundColors.length;
  return backgroundColors[index];
}

export default function EmailLogAvatar({
  name,
  email,
  size = 'md',
}: EmailLogAvatarProps) {
  const { saved } = useSiteTheme('admin');
  const initials = getInitials(name, email);
  // With a saved theme every avatar uses the brand colour; otherwise keep the per-name colours
  const bgColor = saved.primary_color ? 'bg-brand-blue-600' : getBackgroundColor(name, email);

  return (
    <div
      className={`${sizeClasses[size]} ${bgColor} rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0`}
    >
      {initials}
    </div>
  );
}
